import React, { memo } from 'react'
import de from 'react-intl/locale-data/de'
import { useSelector } from 'react-redux'

import { DialogProvider } from '@galo-monitor/dialog'
import { I18nProvider, dictionaries } from '@galo-monitor/i18n'
import { StoreProvider } from '@galo-monitor/stores'
import { selectLanguage } from '@galo-monitor/stores/language/selectorLanguage'
import { SnackbarsProvider } from '@galo-monitor/web-components/Snackbar'
import withGlobalStyles from '@galo-monitor/web-components/styles/hoc/withGlobalStyles'

import ScreenRouter from '~/screens/ScreenRouter'
import store from '~/store'

import 'moment/locale/pt-br'
import 'moment/locale/de'

// eslint-disable-next-line react/prop-types
const I18nMemorized = memo(({ children }) => {
  const { selected, defaultLanguage } = useSelector(selectLanguage)
  const selectedLanguage = selected in dictionaries ? selected : defaultLanguage

  return (
    <I18nProvider
      language={ selectedLanguage }
      dictionaries={ dictionaries }
      additionalsLocaleData= { [...de] }
    >
      {children}
    </I18nProvider>
  )
})

const ScreenRouterMemorized = memo(() => <ScreenRouter />)

const App = () => (
  <StoreProvider store={ store }>
    <I18nMemorized>
      <SnackbarsProvider>
        <DialogProvider>
          <ScreenRouterMemorized />
        </DialogProvider>
      </SnackbarsProvider>
    </I18nMemorized>
  </StoreProvider>
)

export default withGlobalStyles(App)
